import { useEffect, useContext, useState, useRef } from "react";
import WithLogin from "../../hoc/WithLogin.tsx";
import styleColor from "../../assets/kits/colors/colors.module.scss";
import CustomButton from "../../components/kits/custom-button/CustomButton";
import NameDrawer from "./NameDrawer.jsx";
import Loader from "../superAdminPanel/utils/Loader.jsx";
import {
  ArrowRightIcon,
  ArrowLeftIcon,
  DeliveryExpressIcon,
  CheckIcon,
  AddIcon,
  TrashIcon,
} from "../kits/Icons/Icons";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import DiscountCodeDrawer from "./DiscountCodeDrawer";
import FailPaymentDrawer from "./FailPaymentDrawer.jsx";
import ProductDetailDrawer from "./ProductDetailDrawer";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";
import {
  useParams,
  useSearchParams,
  useNavigate,
  userProps,
  NavLink,
  redirect,
  useHistory,
  useLocation,
} from "react-router-dom";

import useAxios from "../../services/useAxios";
import DrawerTxtBtn from "../common/DrawerTxtBtn";
import InsufficientProductDrawer from "../orders/insufficientProductDrawer";

const Items = ({
  id,
  title,
  address,
  selected,
  setSelectedId,
  icon,
  plus,
  trash,
  itemClass,
  setOpen,
  allClick = false,
  setDiscount,
}) => {
  return (
    <>
      {allClick ? (
        <a
          onClick={() => {
            if (plus) {
              setOpen(true);
            } else {
              setDiscount(0);
            }
          }}
        >
          <div
            className={` ${itemClass} mr-x-20 d-flex justify-content-between `}
          >
            <div
              id={`address-${id}`}
              type="checkbox"
              className="address-item d-flex  mr-l-12"
            >
              <div
                className={`d-flex align-items-center mr-l-12 ${
                  !icon && "d-none"
                }`}
              >
                {icon}
              </div>
              <div>
                <div
                  className="title title-h5-m  d-flex align-items-center text-start mr-b-4"
                  style={{ color: styleColor.gray_900 }}
                >
                  {title == "" ? "------" : title}
                </div>
                <div className="description desc-l d-flex align-items-center text-start">
                  {address
                    ? address.indexOf("&") != -1
                      ? address.split("&")[0] + "،" + address.split("&")[1]
                      : address
                    : ""}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center">
              {plus || trash ? (
                <button
                  className="btn p-0"
                  onClick={() => {
                    if (plus) {
                      setOpen(true);
                    } else {
                      setDiscount(0);
                    }
                  }}
                >
                  {trash ? (
                    <TrashIcon color={styleColor.gray_900} />
                  ) : (
                    <AddIcon color={styleColor.gray_900} />
                  )}
                </button>
              ) : (
                <span
                  className={`rounded-pill border d-flex me-1`}
                  style={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                    backgroundColor: selected == id && styleColor.blue_600,
                  }}
                  onClick={() => {
                    setSelectedId(id);
                  }}
                >
                  {selected == id && (
                    <CheckIcon
                      width="10px"
                      height="10px"
                      containerIconClassName={"d-flex mx-auto my-auto"}
                    />
                  )}
                </span>
              )}
            </div>
          </div>
        </a>
      ) : (
        <div
          className={` ${itemClass} mr-x-20 d-flex justify-content-between `}
        >
          <div
            id={`address-${id}`}
            type="checkbox"
            className="address-item d-flex  mr-l-12"
          >
            <div
              className={`d-flex align-items-center mr-l-12 ${
                !icon && "d-none"
              }`}
            >
              {icon}
            </div>
            <div>
              <div
                className="title title-h5-m  d-flex align-items-center text-start mr-b-4"
                style={{ color: styleColor.gray_900 }}
              >
                {title == "" ? "------" : title}
              </div>
              <div className="description desc-l d-flex align-items-center text-start">
                {address
                  ? address.indexOf("&") != -1
                    ? address.split("&")[0] + "،" + address.split("&")[1]
                    : address
                  : ""}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {plus || trash ? (
              <button
                className="btn p-0"
                onClick={() => {
                  if (plus) {
                    setOpen(true);
                  } else {
                    setDiscount(0);
                  }
                }}
              >
                {trash ? (
                  <TrashIcon color={styleColor.gray_900} />
                ) : (
                  <AddIcon color={styleColor.gray_900} />
                )}
              </button>
            ) : (
              <span
                className={`rounded-pill border d-flex me-1`}
                style={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  backgroundColor: selected == id && styleColor.blue_600,
                }}
                onClick={() => {
                  setSelectedId(id);
                }}
              >
                {selected == id && (
                  <CheckIcon
                    width="10px"
                    height="10px"
                    containerIconClassName={"d-flex mx-auto my-auto"}
                  />
                )}
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default function CheckOut() {
  const [discountOpen, setDiscountOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const auth = useContext(AuthenticationContext);
  const [selectedId, setSelectedId] = useState(1);
  const [selectedId2, setSelectedId2] = useState(1);
  const [AllPrice, setAllPrice] = useState(0);
  const [allDiscount, setAllDiscount] = useState(0);
  const [sendPrice, setSendPrice] = useState(0);
  const [SupplierItems, setItems] = useState([]);
  const [DefaultAddress, setDefaultAddress] = useState("");
  const [discount, setDiscount] = useState(0);
  const [giftCode, setGiftCode] = useState(0);
  const [update, setUpdate] = useState(false);
  const [giftId, setGiftId] = useState(0);
  const [inventoryList, setInventoryList] = useState([]);
  const [inventoryDrawer, setInventoryDrawer] = useState(false);
  const [minOrderDrawer, setMinOrderDrawer] = useState(false);
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const [payStatusDrawer, setPayStatusDrawer] = useState(false);
  const [nameDrawer, setNameDrawer] = useState(false);
  const [firstGiftCode, setFirstGiftCode] = useState(false);
  const [justDiscount, setJustDiscount] = useState(0);
  const winWidth = useWindowSize();
  const { shoppingList, updateShoppingList } = useContext(
    ShoppingCartItemContext
  );
  const { id } = useParams();
  const [searches] = useSearchParams();
  const { execute: checkGifCode } = useAxios("api/check_giftcode");

  const navigate = useNavigate();
  const login = useRef(0);
  const { execute: addOrder } = useAxios("api/add_order");
  const { execute: firstGift } = useAxios("api/first_purchase_gift");
  const { execute: checkInventoryApi } = useAxios("api/check_inventory");
  const items = shoppingList.filter(
    (Item) => +Item.supplier_info.suppliers__id == id
  );

  useEffect(() => {
    console.log(document.referrer, "document.referrer");
    console.log(navigate, "document.referrer");
    setPayStatusDrawer(searches.get("status") == 0);
    firstGift("").then((data) => {
      if (data.status == 1) {
        setGiftCode(data.giftCode);
        setFirstGiftCode(true);
      } else {
        setGiftCode(0);
        setFirstGiftCode(false);
      }
    });
  }, [auth.userInfo.addresses.length, +discount]);

  useEffect(() => {
    let InItem = false;
    let AddressCheck = false;
    let emptyAddress = 0;
    //اگر سبد خرید آدرس نداشت از آدرس پیشفرض خود کاربر استفاده میکند و بعد بررسی میکند که اگر سبد خرید آدرس دارد از آن استفاده کند
    let array = auth.userInfo.addresses.filter(
      (a) => a.is_default == 1 && a.status != -1
    );
    if (array.length > 0) {
      setDefaultAddress(array[0]);
      setLoader(false);
      console.log("first state");
      AddressCheck = true;
    } else {
      emptyAddress += 1;
      console.log("first state false");
    }

    let price = 0;
    let discounts = 0;
    console.log(items, "items");
    if (items.length > 0) {
      InItem = true;
      items.map((item) => {
        item.items.map((value) => {
          price =
            price +
            parseInt(value.current_count) * parseInt(value.apo_info.price);
          discounts =
            discounts +
            parseInt(value.current_count) * parseInt(value.apo_info.discount);
        });
      });
      setAllPrice(price);
      setAllDiscount(discounts);

      items.length != 0 &&
        items[0].supplier_info.send_in_cost != null &&
        setSendPrice(items[0].supplier_info.send_in_cost);

      // items.length != 0 &&
      //   items[0].user_Address[0] != null &&
      //   items[0].user_Address[0].status != -1 &&
      //   setDefaultAddress(items[0].user_Address[0]);

      if (
        items.length != 0 &&
        items[0].user_Address[0] != null &&
        items[0].user_Address[0].status != -1
      ) {
        console.log("seconde state");
        setDefaultAddress(items[0].user_Address[0]);
        setLoader(false);
        AddressCheck = true;
      } else {
        console.log("seconde state false");
        emptyAddress += 1;
      }
    }
    if (AddressCheck && InItem) {
      console.log("three state");
      setLoader(false);
    }
    if (emptyAddress == 2) {
      setLoader(false);
    }
  }, [items]);

  useEffect(() => {
    updateShoppingList();
  }, []);
  const AddOrder = async () => {
    if (DefaultAddress) {
      await addOrder({
        Address_id: DefaultAddress.id,
        delivery_type: 1,
        delivery_price: giftCode != 0 && +discount != 0 ? 0 : +sendPrice,
        total_price:
          giftCode != 0 && +discount != 0 ? +AllPrice : +sendPrice + +AllPrice,
        supplier_id: id,
        gift_id: giftId,
      }).then((res) => {
        if (res.status == 1) {
          window.location = res.url;
        }
      });
    } else {
      if (auth.isLogin) {
        navigate(`/your-address/${id}`);
      } else {
        document.getElementById("WithLogin").click();
      }
    }
  };
  const checkCode = (code) => {
    let form = new FormData();
    form.append("giftCode", code);
    checkGifCode(form).then((data) => {
      if (data.status == 1) {
        if (data.result.type == 0) {
          setJustDiscount((+data.result.value * +AllPrice) / 100);
          setDiscount((+data.result.value * +AllPrice) / 100 + +sendPrice);
        } else {
          setJustDiscount(+data.result.value);
          setDiscount(+data.result.value + +sendPrice);
        }
        if (firstGiftCode) {
          setSendPrice(0);
        }
        setGiftId(data.result.id);
      }
    });
  };
  const checkInventoryFunc = (supplierId) => {
    if (auth.userInfo.lastname == "" || auth.userInfo.firstname == "") {
      setNameDrawer(true);
    } else {
      checkInventoryApi({ supplier_id: supplierId }).then((result) => {
        if (result.cartItems.length == 0) {
          if (
            minOrderChecker(
              items[0].supplier_info.min_order_amount,
              totalAmountItem(items[0].items)
            )
          ) {
            AddOrder();
          } else {
            setMinOrderDrawer(true);
          }
        } else if (result.cartItems.length > 0) {
          setInventoryList(
            result.cartItems.map((value) => value.product_title)
          );
          setInventoryDrawer(true);
          updateShoppingList();
        }
      });
    }
  };
  const totalAmountItem = (array) => {
    let count = 0;
    for (let i = 0; i < array.length; i++) {
      count +=
        parseInt(array[i].current_count) *
        (parseInt(array[i].apo_info.price) -
          parseInt(array[i].apo_info.discount));
    }
    return count;
  };
  const minOrderChecker = (minOrder, totalAmount) => {
    if (minOrder < totalAmount) return true;
    else return false;
  };
  const payChecker = () => {
    if (
      minOrderChecker(
        items[0].supplier_info.min_order_amount,
        totalAmountItem(items[0].items)
      )
    ) {
      AddOrder();
    } else {
      setMinOrderDrawer(true);
      setInventoryDrawer(false);
    }
  };

  return (
    <>
      {loader && <Loader />}
      <div
        className="d-flex flex-wrap justify-content-between"
        style={{ paddingBottom: "3px" }}
      >
        <div
          className="w-100"
          style={{ marginBottom: giftCode != 0 ? "124px" : "64px" }}
        >
          <div
            className="d-flex pd-x-20 pd-y-12 mr-b-12 align-items-center"
            style={{ color: styleColor.gray_900 }}
          >
            <button
              onClick={() => navigate(-1)}
              className="btn mr-0 pd-x-0 pd-t-0 pd-b-2"
              style={{ color: styleColor.gray_900 }}
            >
              <ArrowRightIcon />
            </button>
            <span className="title-h3-b mr-r-8">تایید نهایی و پرداخت</span>
          </div>
          <div>
            <div
              className="d-flex justify-content-between align-items-center"
              // style={{ height: 48 }}
            >
              <div className="mr-r-20 d-flex align-items-center">
                {/* <NavLink to="/user-profile"><ArrowRightIcon /></NavLink> */}

                <span className=" title-h4-m" style={{ color: "#000000" }}>
                  روش تحویل سفارش
                </span>
              </div>
              <div>
                <NavLink
                  to={{
                    pathname: `/your-address/${id}`,
                  }}
                  className="btn title-h5-m d-flex pd-12 border-0"
                >
                  <span
                    className="mr-l-6 title-h4-m"
                    style={{ color: styleColor.gray_900 }}
                  >
                    تغییر آدرس
                  </span>
                  <ArrowLeftIcon />
                </NavLink>
              </div>
            </div>
            {DefaultAddress ? (
              <Items
                id={1}
                title={`ارسال با پیک ${DefaultAddress.title}`}
                address={DefaultAddress.address}
                selected={selectedId}
                setSelectedId={setSelectedId}
                itemClass={"mr-b-32 mr-t-12"}
                icon={
                  <DeliveryExpressIcon
                    color={styleColor.gray_900}
                    width="16px"
                    height="16px"
                  />
                }
              />
            ) : (
              <div className="w-100 pd-x-20 mr-t-8 mr-b-32">
                <CustomButton
                  className="pd-x-16 w-100"
                  buttonStyle="primary"
                  state="default"
                  size="large"
                  isIcon="false"
                  onClick={() => {
                    if (auth.isLogin) {
                      navigate(`/your-address/${id}`);
                    } else {
                      document.getElementById("WithLogin").click();
                    }
                  }}
                >
                  <span className="title-h4-m">آدرس خود را انتخاب کنید</span>
                </CustomButton>
              </div>
            )}
          </div>
          <hr className="my-0" />
          <div>
            <div
              className="d-flex justify-content-between align-items-center  mr-t-32"
              // style={{ height: 48 }}
            >
              <div className="mr-r-20 mr-b-16 d-flex align-items-center">
                {/* <NavLink to="/user-profile"><ArrowRightIcon /></NavLink> */}

                <span className="title-h4-m" style={{ color: "#000000" }}>
                  روش پرداخت
                </span>
              </div>
            </div>
            <Items
              itemClass="mr-b-20"
              id={1}
              title={"پرداخت آنلاین"}
              address={"درگاه آسان پرداخت"}
              selected={selectedId2}
              setSelectedId={setSelectedId2}
            />
            <Items
              itemClass="mr-b-32"
              id={2}
              title={"آیا کد تخفیف دارید؟"}
              address={
                +discount == 0
                  ? "کد تخفیف را وارد کنید."
                  : `${parseInt(justDiscount).toLocaleString()} تخفیف دارید.`
              }
              selected={selectedId}
              setSelectedId={setSelectedId}
              plus={+discount == 0}
              trash={!(+discount == 0)}
              allClick={true}
              setDiscount={setDiscount}
              setOpen={setDiscountOpen}
            />
          </div>
          <hr className="mx-0 mr-t-0 mr-b-32" />
          <div>
            <div
              className="d-flex justify-content-between align-items-center mr-b-24"
              // style={{ height: 48 }}
            >
              <div className="mr-r-20 d-flex align-items-center">
                {/* <NavLink to="/user-profile"><ArrowRightIcon /></NavLink> */}

                <span className=" title-h4-m" style={{ color: "#000000" }}>
                  {" "}
                  جزئیات پرداخت و اقلام{" "}
                </span>
              </div>
              <div>
                <button
                  onClick={() => {
                    //   setIsOpenDrawer(true);
                    setDetailOpen(true);
                  }}
                  className="btn title-h5-m d-flex mr-l-8 border-0"
                >
                  <span
                    className="mr-l-6 title-h4-m"
                    style={{ color: styleColor.gray_900 }}
                  >
                    {" "}
                    اقلام سفارش
                  </span>
                  <ArrowLeftIcon />
                </button>
              </div>
            </div>
            <div className="d-flex justify-content-between mr-x-20 mr-b-14">
              <span className="txt-t2-l">مبلغ اقلام</span>
              <span className="txt-t2-l">
                {parseInt(AllPrice).toLocaleString()} تومان
              </span>
            </div>
            <div className="d-flex justify-content-between mr-x-20 mr-b-16">
              <span className="txt-t2-l">هزینه پیک</span>
              {+discount != 0 && firstGiftCode ? (
                <div className="d-flex">
                  <span className="txt-t2-l">رایگان</span>{" "}
                  <span className="txt-t2-l text-decoration-line-through">
                    {` ${parseInt(sendPrice).toLocaleString()} تومان`}
                  </span>
                </div>
              ) : (
                <span className="txt-t2-l">
                  {sendPrice == "0"
                    ? "رایگان"
                    : ` ${parseInt(sendPrice).toLocaleString()} تومان`}
                </span>
              )}
            </div>
            {+allDiscount + +discount != 0 && (
              <div className="d-flex justify-content-between mr-x-20 mr-b-16">
                <span className="txt-t2-l">سود شما از این خرید</span>
                <span className="txt-t2-l">
                  {` ${(
                    parseInt(allDiscount) + parseInt(discount)
                  ).toLocaleString()} تومان`}
                </span>
              </div>
            )}
            <hr className="my-0 mr-x-20" />
            <div className="d-flex justify-content-between mr-x-20 mr-y-16">
              <span className="txt-t2-l">قابل پرداخت</span>
              <span className="txt-t2-l">
                {(
                  parseInt(AllPrice) -
                  parseInt(allDiscount) +
                  parseInt(sendPrice) -
                  parseInt(discount)
                ).toLocaleString()}{" "}
                {/* {(
                  (giftCode != 0 && +discount != 0
                    ? +AllPrice
                    : +sendPrice + +AllPrice) -
                  (+discount + +allDiscount)
                ).toLocaleString()}{" "} */}
                تومان
              </span>
            </div>
          </div>
        </div>
        <div
          className=" pd-b-20 pd-x-20 position-fixed bottom-0 bg-white"
          style={{ width: winWidth.width > 600 ? "600px" : "100%" }}
        >
          {giftCode != 0 && discount == 0 && (
            <div className=" pd-t-12">
              <CustomButton
                buttonStyle="primary"
                className="d-flex justify-content-center w-100"
                style={{ height: 48 }}
                onClick={() => {
                  checkCode(giftCode);
                  // navigator.clipboard.writeText(giftCode);
                }}
              >
                <div className="txt-t2-l">
                  {" "}
                  اعمال 20 هزار تومان تخفیف برای سفارش اول
                </div>
                {/* <div className="title-h4-m">کپی کردن</div> */}
              </CustomButton>
            </div>
          )}
          <div className="d-flex pd-t-12">
            <div className="d-flex flex-column w-50">
              <small
                style={{ color: styleColor.gray_600 }}
                className="text-secondary desc-m mr-b-4"
              >
                قیمت نهایی
              </small>
              <strong
                style={{ color: styleColor.gray_900 }}
                className=" title-h5-m"
              >
                {(
                  parseInt(AllPrice) -
                  parseInt(allDiscount) +
                  parseInt(sendPrice) -
                  parseInt(discount)
                ).toLocaleString()}
                {/* {(
                  (giftCode != 0 && +discount != 0
                    ? +AllPrice
                    : +sendPrice + +AllPrice) -
                  (+discount + +allDiscount)
                ).toLocaleString()}{" "} */}
                تومان
              </strong>
            </div>
            {/* </div> */}

            <CustomButton
              className="pd-x-16 w-50 "
              buttonStyle={DefaultAddress ? "primary" : "secondary"}
              state="default"
              size="large"
              isIcon="false"
              onClick={() => {
                if (auth.isLogin) {
                  if (DefaultAddress) {
                    checkInventoryFunc(id);
                  } else {
                    navigate(`/your-address/${id}`);
                  }
                } else {
                  document.getElementById("WithLogin").click();
                }
              }}
            >
              {DefaultAddress ? (
                <span className="title-h4-m">پرداخت آنلاین</span>
              ) : (
                <span className="title-h4-m">انتخاب آدرس</span>
              )}
            </CustomButton>
          </div>
        </div>
        <WithLogin
          id="WithLogin"
          buttonStyle="text"
          className="w-100"
          style={{ whiteSpace: "nowrap", display: "none" }}
        >
          log in
        </WithLogin>

        <FailPaymentDrawer
          isOpen={payStatusDrawer}
          setIsOpen={setPayStatusDrawer}
          AddOrder={AddOrder}
        />

        <NameDrawer
          isOpen={nameDrawer}
          setIsOpen={setNameDrawer}
          id={auth.userInfo.id}
          LastName={auth.userInfo.lastname}
          FirstName={auth.userInfo.firstname}
        />

        <DiscountCodeDrawer
          isOpen={discountOpen}
          setIsOpen={setDiscountOpen}
          setDiscount={setDiscount}
          setGiftId={setGiftId}
          total={+AllPrice}
          setJustDiscount={setJustDiscount}
        />
        {items[0] && (
          <ProductDetailDrawer
            isOpen={detailOpen}
            setIsOpen={setDetailOpen}
            items={items[0].items}
          />
        )}
        <InsufficientProductDrawer
          supplierId={id}
          productTitles={inventoryList}
          isOpened={inventoryDrawer}
          setIsOpened={setInventoryDrawer}
          payButtonHandler={() => {
            payChecker();
          }}
        />
        <DrawerTxtBtn
          isOpen={minOrderDrawer}
          setIsOpen={setMinOrderDrawer}
          height={140}
          mainText="مجموع مبلغ سفارش از حداقل سفارش این فروشگاه کمتر است."
          btnText="منو سوپرمارکت"
          to={`shop/${id}`}
        />
      </div>
    </>
  );
}
